import { AxiosInstance } from 'axios';
import { ModuleDetails, ModuleOverview } from 'types/module';
import { Result } from 'services/Result';
import { ModuleTableOfContents } from 'types/learningHub/moduleContents';
import i18next from 'i18next';

export class LearningHubService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getModules = async () => {
    const response = await this.axiosInstance.get<Result<{ modules: ModuleOverview[] }>>(`api/modules`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data.modules;
    }
    throw Error('There was an internal error while fetching modules.');
  };

  getModuleDetails = async (slug: string) => {
    const response = await this.axiosInstance.get<Result<ModuleDetails>>(`api/modules/${slug}`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching module details.');
  };

  getModuleContents = async (id: string) => {
    const response = await this.axiosInstance.get<Result<ModuleTableOfContents>>(`api/modules/${id}/contents`);
    if (response.data && response.data.data && !response.data.isError) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching module contents.');
  };

  getLearningHubTestContent = async (testId: string) => {
    const response = await this.axiosInstance.get<Result<any>>(`api/rhapsode-content/${testId}`);
    if (response.data && response.data.data && !response.data.isError) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching test contents.');
  };

  

  markResourceAsDone = async (contentId: string) => {
    const response = await this.axiosInstance.post<Result<any>>(`api/Progress/MarkResourceAsDone`, { contentId });
    if (response.status === 200) {
      return;
    }

    throw Error('There was an internal error while marking the resource as done.');
  };
}
export default LearningHubService;
